export const CONFIRMED_GET_ASSIGNED_PATIENTS = "CONFIRMED_GET_ASSIGNED_PATIENTS";
export const FAILED_GET_ASSIGNED_PATIENTS = "FAILED_GET_ASSIGNED_PATIENTS";

export const CONFIRMED_GET_TODAY_FOLLOWUPS = "CONFIRMED_GET_TODAY_FOLLOWUPS";
export const FAILED_GET_TODAY_FOLLOWUPS = "FAILED_GET_TODAY_FOLLOWUPS";

export const CONFIRMED_GET_UPCOMING_FOLLOWUPS = "CONFIRMED_GET_UPCOMING_FOLLOWUPS";
export const FAILED_GET_UPCOMING_FOLLOWUPS = "FAILED_GET_UPCOMING_FOLLOWUPS";

export const CONFIRMED_GET_EMERGENCY_PATIENTS = "CONFIRMED_GET_EMERGENCY_PATIENTS";
export const FAILED_GET_EMERGENCY_PATIENTS = "FAILED_GET_EMERGENCY_PATIENTS";

export const CONFIRMED_MARK_EMERGENCY = "CONFIRMED_MARK_EMERGENCY";
export const FAILED_MARK_EMERGENCY = "FAILED_MARK_EMERGENCY";

export const CONFIRMED_GET_DROPPED_PATIENTS = "CONFIRMED_GET_DROPPED_PATIENTS";
export const FAILED_GET_DROPPED_PATIENTS = "FAILED_GET_DROPPED_PATIENTS";
export const CONFIRMED_UPDATE_PANCHKARMA = "CONFIRMED_UPDATE_PANCHKARMA";
export const FAILED_UPDATE_PANCHKARMA = "FAILED_UPDATE_PANCHKARMA";

export const CONFIRMED_GET_71221_FOLLOWUPS = "CONFIRMED_GET_71221_FOLLOWUPS";
export const FAILED_GET_71221_FOLLOWUPS = "FAILED_GET_71221_FOLLOWUPS";
